/* eslint-disable camelcase */
import React, { memo, useState } from 'react';
// import TextField from '../../../styled-base/input/text';
import { krdetailConstants, updateDisabledMessage, updateDisabledMessageWithGracePeriod } from '../../../constants/krdetails.constants';
import SimpleEditor from './simple_editor';
// import YesNo from './yesno';
import ScaleRange from './scale-range';
import YesNoToggleBtn from './YesNoToggleButton';
import UpdateText from './updateDialogText';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

const DataRow = (props) => {
    const { t } =  useTranslation()
    const {
        id, create_at_text, comment, m_data, textLabel,
        source, counting, lowerLimit, upperLimit, create_at,
        rowIndex,retainData,
    } = props;
    const isEditMode = !((m_data == null || m_data == '' || m_data == undefined));
    const isSurvey = (source == 5);
    const isYesOrNo = (isSurvey && counting == 5);
    const isScale = (isSurvey && counting == 6);
    const updateValueDisabled = (source == krdetailConstants.SOURCE_WORKSTREAM) || props.disableMdata ;
    const commentDisabled = (() => {
        if (source == krdetailConstants.SOURCE_WORKSTREAM) {
            let midnight = new Date();
            midnight.setUTCHours(0, 0, 0, 0);
            if (create_at >= Math.floor(midnight.getTime() / 1000)) {
                return true;
            }
        }
        return false;
    })();
    const updateDisabledHoverMessage = () => {
        if (props.disableMdata || props.disableNarrative) {
            if (props.gracePeriod) {
                return updateDisabledMessageWithGracePeriod.replace('$NumOfDays', props.gracePeriod);
            } else {
                return updateDisabledMessage;
            }
        }
    }
    const [editMode, setEditMode] = useState(isEditMode);
    const [tempComment, setTempComment] = useState(comment);
    const onChangeName = (e: any) => {
        const v: any = e.target.value.trim();
        const exp = /^-?\d+(?:\.\d+)?$/;
        if (v) {
            if (exp.test(v) === false && v.indexOf('-') === -1 && v.indexOf('.') === -1) {
                e.preventDefault();
                return false;
            }
            if (v.split('-').length > 2 || v.split('.').length > 2 || v.indexOf('-.') !== -1) {
                e.preventDefault();
                return false;
            }
        }
        props.onChangeText(id, v);
        return true;
    }

    const onChangeComment = (e: any) => {
        let t: any = e.getData();
        if (typeof t !== 'undefined' && t) {
            t = t.replace(/(<p>&nbsp;<\/p>)*$/i, '');
        }
        props.onChangeText(id, t, 'comment');
    }

    const onChangeCommentEmoji = (e: any) => {
        const t: any = e.innerHTML;
        props.onChangeText(id, t, 'comment');
    }

    // useEffect(() => {
    //     setTempComment(comment);
    // }, [])

    const onChangeYesNo = (val: string) => {
        props.onChangeText(id, val);
    }

    const onChangeRange = (e: any, val: number) => {
        props.onChangeText(id, val);
    }

    const noChangeText = (e: any) => {
        e.preventDefault();
        return false;
    }

    const onPasteChangeText = (e: any) => {
        const regex = /^-?\d*\.?\d+$/;
        if (!regex.test(e.nativeEvent.clipboardData.getData('Text'))) {
            e.preventDefault();
        }
    }

    const updateKrValues = (e, mData, yesOrNo) => {
        let nodeVal = 2;
        if (yesOrNo) {
            nodeVal = 1;
        }
        const parentElem: HTMLElement = (e.target as HTMLElement).parentElement;
        setTimeout(() => {
            const focusedElem: any = parentElem.childNodes[nodeVal];
            const elem: string = focusedElem.nodeName;

            if (elem === 'INPUT' || elem === 'A' || elem === 'BUTTON') {
                focusedElem.focus();
            } else if (mData === 'No') {
                document.getElementById(`no-btn-${id}`).focus();
            } else if (mData === 'Yes') {
                document.getElementById(`yes-btn-${id}`).focus();
            } else if ((parentElem.childNodes[2].firstChild as HTMLElement).hasAttribute('tabindex')) {
                (parentElem.childNodes[2].firstChild as HTMLElement).focus();
            } else {
                const childNodesList = parentElem.childNodes[2].firstChild.childNodes;
                // let childNodesList = parentElem.childNodes[0].lastChild.childNodes
                const childNodeArr: ChildNode[] = Array.from(childNodesList);
                childNodeArr.forEach(node => {
                    if ((node as HTMLElement).hasAttribute('tabindex')) {
                        (node as HTMLElement).focus();
                    }
                });
            }
        }, 0);
    }

    const handleSetEdit = (e, mData, textValId) => {
        const focusEl = document.getElementById(textValId)
        if (focusEl) focusEl.focus()
        setEditMode(false);
        updateKrValues(e, mData, isYesOrNo);
    }

    const TextMode = ({ textValId }) => {
        let mData = m_data;
        if (isYesOrNo) {
            mData = (m_data == 2) ? 'Yes' : 'No';
        }
        return (
            <>
                <span
                    role="button"
                    style={{ cursor: 'pointer' }}
                    onClick={(e) => { handleSetEdit(e, mData, textValId) }}
                    tabIndex={0}
                    aria-label={`${mData} editable`}
                    onKeyDown={(e: React.KeyboardEvent) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            handleSetEdit(e, mData, textValId)
                        }
                    }}
                >
                    { mData }
                </span>
            </>
        )
    }

    let FieldComp: any = null;
    const textValId = `ukr-text-value-${id}`;

    if (isYesOrNo) {
        FieldComp = <YesNoToggleBtn value={m_data} onChange={onChangeYesNo} id={id} updateValueDisabled={updateValueDisabled}/>;
    } else if (isScale) {
        FieldComp = <ScaleRange
            value={m_data}
            handleChange={onChangeRange}
            min={lowerLimit}
            max={upperLimit}
            updateValueDisabled={updateValueDisabled}
        />;
    } else {
        FieldComp = <UpdateText
            inputProps={{
                id: `kr-data-id${id}`,
                name: `kr_data_${id}`,
                value: (m_data == undefined ? '' : m_data),
                placeholder: textLabel,
                maxLength: 15,
                disabled: updateValueDisabled,
                onDrag: noChangeText,
                onPaste: onPasteChangeText,
                onDrop: noChangeText,
            }}
            onChangeText={onChangeName}
        />;
    }

    let editorPlaceholderText = (m_data == undefined)
        ? t('Enter an optional narrative to provide details for this update.')
        : t('No narrative was provided with this update.');
    let commentText = tempComment;

    if (commentDisabled) {
        editorPlaceholderText = t('Narrative editing is disabled for the current day and future dates.');
        if (commentText) {
            commentText += '<div class="kr-data-info" >' + editorPlaceholderText + '</div>';
        }
    }

    return (
        <tr className={`kr-data-row ${(rowIndex === 0 ? ' kr-data-row-new' : '')}`}>
            <td className="kr-data-row-date">
                <div className="kr-data-date">
                    {create_at_text}
                    {
                        retainData &&
                            <span>*</span>
                    }
                </div>
            </td>
            <td className="kr-data-row-input" title={props.disableMdata ? updateDisabledHoverMessage() : ''}>
                <div tabIndex={-1} id={textValId} className="sr-only" style={{ outline: '0px !important' }} />
                {FieldComp}
            </td>
            <td className="kr-data-row-comment">
                <div className="kr-data-comment" title={props.disableNarrative ? updateDisabledHoverMessage() : ''}>
                    <SimpleEditor
                        key={`kr-comment-${id}`}
                        text={commentText}
                        id={id}
                        onChange={onChangeComment}
                        onChangeEmoji={onChangeComment}
                        placeHolder={editorPlaceholderText}
                        readOnly={commentDisabled || props.disableNarrative}
                    />
                </div>
            </td>
        </tr>
    )
}
const DataHeaderRow = memo(() => {
    const { t } = useTranslation();
    return (
        <tr className="kr-data-row kr-data-header-row">
            <th className="kr-data-row-date">
                {t('DATE')}
            </th>
            <th className="kr-data-row-input">
                {t('UPDATE VALUE')}
            </th>
            <th className="kr-data-row-comment">
                {t('NARRATIVE')}
            </th>
        </tr>
    );
});

const MemoziedDataRow = memo(DataRow, (prevProps: any, nextProps: any) => {
    if (prevProps.m_data !== nextProps.m_data
    || prevProps.comment !== nextProps.comment) {
        return false;
    }
    return true;
});

const KRDataTable = (props) => {
    const {t} = useTranslation()
    const { rows, metric } = props;
    let textLabel = t('Enter #'); // measurement is number
    if (metric.metric == 2) { // measurement is currency
        textLabel = t('Enter $');
    } else if (metric.metric == 3) { // measurement is percentage
        textLabel = t('Enter %');
    }
    if (metric.source == krdetailConstants.SOURCE_WORKSTREAM) {
        textLabel = '';
    }

    return (
        <table className="kr-data-table" aria-describedby="update-kr-measurement-heading">
            <tbody>
                <DataHeaderRow />
                {
                    rows.length ? rows.map((r: any, index: number) => <DataRow
                        key={`kr-data-${r.id}`}
                        {...r}
                        textLabel={textLabel}
                        onChangeText={props.onChangeText}
                        source={metric.source}
                        counting={metric.counting}
                        lowerLimit={metric.lower_limit}
                        upperLimit={metric.upper_limit}
                        rowIndex={index}
                    />) : null
                }
            </tbody>
        </table>
    )
}

export default KRDataTable;
